module.exports = __webpack_public_path__ + "assets/manual_osago-06cedef56b25cb52a527685bd46edb4f.pdf";